import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import LoadingComponent from '../LoadingComponent';

type RequireGuestProps = {
  children: ReactNode;
  isAuthenticated: boolean;
  loading: boolean;
};

const RequireGuest = ({
  children,
  isAuthenticated,
  loading,
}: RequireGuestProps) => {
  if (loading) {
    return <LoadingComponent message="Loading..." />;
  }

  if (isAuthenticated) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};

export default RequireGuest;
